export default {
  payment: '充值',
  order: '订单',
  paymentMethod: '付款方式',
  choosePaymentMethod: '选择付款方式',
  moreOptions: '更多充值方式',
  bank: '银行',
  name: '名字',
  enterCardOwnerName: '输入您付款卡的持卡人姓名',
  phoneNumber: '手机号码',
  enterYourCardPhoneNumber: '输入您付款卡对应的手机号',
  lowest: '最低',
  highest: '最高',
  rmb: '元',
  point: '积分',
  enterCustomAmount: '输入自定义金额',
  payAmount: '付款金额',
  cardNumber: '卡号',
  enterCardNumber: '请输入付款卡卡号',
  payImmediately: '立即支付',
  have: '有',
  personSuccess: '的人成功充值',
  channelUnavailable: '暂无可用通道',
  paymentType: '支付类型',
  orderUnavailable: '订单不存在',
  error: '错误',
  requestAgain: '订单已存在，请重新发起',
  orderNumber: '订单号',
  enterCardOwner: '请输入付款银行卡姓名',
  enterRealName: '请输入您的真实姓名',
  enterPhone: '请输入您的手机号码',
  enterAnInteger: '请输入整数',
  paymentSupport: '充值支持',
  requestTooFrequently: '订单发起过于频繁',
  needToSlowlyRequest: '对不起，因您频繁发起订单但未提交支付',
  waitFiveMinutes: '请您休息五分钟再尝试，谢谢您的配合',
  done: '完成',
  chooseLanguage: '选择语言',
  en: '英文',
  vn: '越南文',
  cn: '简体中文',
  tw: '繁体中文',
  copy: '复制',
  tips: '温馨提示',
  scanQrcode: '扫描二维码或点击复制地址',
  screenshotAndScript: '查找单号请提供截图以及附言码',
  orderInfo: '订单信息',
  address: '地址',
  scripts: '附言',
  qrcode: '二维码',
  ipBlock: '您已被屏蔽，请联系您的商家',
  invalidName: '未实名认证',
  paid: '支付成功',
  channelMaintain: '通道维护中，请联系客服',
  id_number: '身分證号',
  phone: '手机号',
  fixWrong: '请修改错误',
  formatWrong: '格式不正确',
  mobilePlaceholder: '填写您的手机号码 (e.g. 254123456789)'
}



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN.js